import { Controller } from '@hotwired/stimulus';
export default class PageNavbarController extends Controller {
  connect() {
    console.log('Hello from page--navbar controller');
  }
}
